<template>
  <sub-page title="失业登记查询">
    <div class="query-page">
      <!-- 用户信息 -->
      <div class="user-card">
        <div class="avatar">
          <svg viewBox="0 0 24 24" class="avatar-icon"><circle cx="12" cy="8" r="4" fill="#c8c9cc"/><path d="M4 20 C4 15 8 13 12 13 C16 13 20 15 20 20 Z" fill="#c8c9cc"/></svg>
        </div>
        <div class="user-info">
          <div class="user-name">**杰</div>
          <div class="user-id">**************5619</div>
        </div>
      </div>

      <!-- 信息列表 -->
      <div class="info-list">
        <div class="info-item" v-for="(item, idx) in infoList" :key="idx">
          <span class="info-label">{{ item.label }}</span>
          <span class="info-value">{{ item.value }}</span>
        </div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'UnemployQuery',
  components: { SubPage },
  data() {
    return {
      infoList: [
        { label: '性别', value: '男' },
        { label: '民族', value: '汉族' },
        { label: '出生日期', value: '1992-10-28' },
        { label: '政治面貌', value: '其他' },
        { label: '联系电话', value: '181****9689' },
        { label: '学历', value: '大学本科' },
        { label: '毕业学校', value: '巢湖学院' },
        { label: '健康状况', value: '健康或良好' },
        { label: '户籍性质', value: '外省农村' },
        { label: '户籍区划', value: '安徽省滁州市来安县' },
        { label: '户籍地址', value: '十里村磨盘桥33号' },
        { label: '常住地址', value: '南京高新技术产业开发区内南京软件...' },
        { label: '失业原因', value: '被企业解除或终止劳动关系' },
        { label: '失业时间', value: '2026-01-21' },
        { label: '登记失业地类型', value: '居住地址' },
        { label: '是否申请失业金', value: '是' },
        { label: '培训意愿', value: '其他' },
        { label: '有效状态', value: '有效' }
      ]
    }
  }
}
</script>

<style scoped>
.query-page {
  background: #F3F8FB;
  min-height: 100%;
  padding-bottom: calc(40 * var(--w));
}
.user-card {
  display: flex;
  align-items: center;
  background: #fff;
  padding: calc(32 * var(--w));
  gap: calc(24 * var(--w));
  margin-bottom: calc(16 * var(--w));
}
.avatar {
  width: calc(100 * var(--w));
  height: calc(100 * var(--w));
  border-radius: 50%;
  background: #f2f2f2;
  overflow: hidden;
  flex-shrink: 0;
}
.avatar-icon {
  width: 100%;
  height: 100%;
}
.user-name {
  font-size: calc(36 * var(--w));
  font-weight: bold;
  color: #323233;
  margin-bottom: calc(8 * var(--w));
}
.user-id {
  font-size: calc(28 * var(--w));
  color: #646566;
}
.info-list {
  background: #fff;
}
.info-item {
  display: flex;
  align-items: center;
  min-height: calc(100 * var(--w));
  padding: 0 calc(32 * var(--w));
  border-bottom: 1px solid #f0f0f0;
  gap: calc(24 * var(--w));
}
.info-item:last-child {
  border-bottom: none;
}
.info-label {
  font-size: calc(30 * var(--w));
  color: #323233;
  white-space: nowrap;
  width: calc(260 * var(--w));
  flex-shrink: 0;
}
.info-value {
  flex: 1;
  font-size: calc(30 * var(--w));
  color: #646566;
  text-align: right;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/pages/UnemployQuery.vue